import { useAssignedClientSelection } from "../../../hooks";
import { ReportsAdmin } from "./ReportsAdmin";

export const ReportsClient = () => {
  const { clientOptions, selectedClientId, setSelectedClientId } =
    useAssignedClientSelection();

  return (
    <ReportsAdmin
      clientMode
      assignedClientOptions={clientOptions}
      assignedClientId={selectedClientId}
      onAssignedClientChange={setSelectedClientId}
    />
  );
};
